
export enum PromptDataType {
	Boolean = 'Boolean',
	Date = 'Date',
	JSON = 'JSON',
	Number = 'Number',
	String = 'String',
}
